

import axios from '@/config/http'
import ip from '../config/ip.js'


let base = ip.Ips.ip1
let base2 = ip.Ips.ip2

// 获取所有字典

export const getAllSysCode = params => { return axios.post(`${base}/system/parameterInfoBusiness/get_all_para`,params ); };


//获取系统地区信息
export const querySysRegion = params => { return axios.post(`${base}/system_region/query_sys_region`,params ); };
export const getRegionTree = params => {return axios.post(`${base}/system_region/getRegionTree`,params);};
export const insertRegion = params => {return axios.post(`${base}/system_region/insert`,params);};
export const removeRegion = params => {return axios.get(`${base}/system_region/remove`,{params:params});};
export const isOpenRegion = params =>{return axios.get(`${base}/system_region/isOpen`,{params:params});};
export const updateRegion = params =>{return axios.post(`${base}/system_region/update`,params);};
//查询型号对应的颜色
export const queryColor = params => { return axios.post(`${base}/api/basicSetting/color/query_color`,params ); };


//查询故障大类
export const selectfaultTypes = params => { return axios.post(`${base}/api/basicSetting/faulttypes/selectMainfaultTypes`,params ); };

//查询故障小类
export const selectFaultSubclass = params => { return axios.post(`${base}/api/basicSetting/faultSubclass/queryMainFaultSubclass`,params )};

//添加问题
export const addBasicQuestion = params => { return axios.post(`${base}/api/basicSetting/question/add_question_info`,params )};
export const getBasicQuestionList=params => { return axios.post(`${base}/api/basicSetting/question/query_question_info`,params )};
export const updateBasicQuestionList=params => { return axios.post(`${base}/api/basicSetting/question/update_question_info`,params )};

//故障-问题图片
export const addPaticularQuestion = params => { return axios.post(`${base}/api/basicSetting/paticulars/patch_insert`,params )};
export const getAllInfoImage = params => { return axios.post(`${base}/api/basicSetting/image/get_image_info_all`,params )};

//天气
export const getWeather = params =>{ return axios.get(`${base}/system/weather/getWeather`,{params:params});};






// WEBPACK FOOTER //
// ./src/api/system.js